import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Upload Income Certificate")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institutes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-2 mt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_24 = {
  key: 1,
  type: "button",
  class: "btn btn-success mt-6 p-3",
  disabled: "",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "card mt-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success collapsed",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batch_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee(s)")
  ])
], -1)
const _hoisted_29 = {
  id: "batch_trainee",
  class: "collapse show"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = { class: "card-body border-top p-5" }
const _hoisted_32 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_33 = { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-4 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users fs-3x text-success" })
], -1)
const _hoisted_36 = { class: "col mt-5" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "text-success fw-bold fs-6 mt-2"
}, "Enrolled Trainee(s)", -1)
const _hoisted_38 = { class: "col bg-light-primary d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-4 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-plus fs-3x text-primary" })
], -1)
const _hoisted_41 = { class: "col mt-5 ml-1" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "text-primary fw-bold fs-6 mt-2"
}, "Has Income Certificate", -1)
const _hoisted_43 = { class: "col bg-light-danger d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-4 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-times fs-3x text-danger" })
], -1)
const _hoisted_46 = { class: "col mt-5" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("a", {
  href: "/course-list",
  class: "text-danger fw-bold fs-6 mt-2"
}, "No Income Certificate", -1)
const _hoisted_48 = { class: "row mt-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Trainee Information List", -1)
const _hoisted_50 = { class: "card mb-5 mb-xl-10" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_52 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_53 = { class: "collapse show" }
const _hoisted_54 = { class: "card-body border-top p-6" }
const _hoisted_55 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_56 = {
  key: 0,
  style: {"background":"#f4532e","border-radius":"1em","text-align":"center","color":"white"}
}
const _hoisted_57 = { key: 1 }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-window-close text-center",
  style: {"color":"red","font-size":"20px"}
}, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { key: 2 }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check text-center",
  style: {"color":"green","font-size":"20px"}
}, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt text-light" }, null, -1)
const _hoisted_65 = [
  _hoisted_64
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_uploadCertificateData = _resolveComponent("uploadCertificateData")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.tranche_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: trans.id,
                              label: trans.label,
                              value: trans.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(trans.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _hoisted_13,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Partner",
                        modelValue: _ctx.entity_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                        style: {"width":"100%"},
                        filterable: "",
                        onChange: _ctx.trainingInstitute
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: assoc.id,
                              label: assoc.entity_short_name,
                              value: assoc.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(assoc.entity_name) + " [" + _toDisplayString(assoc.entity_short_name) + "]", 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _hoisted_16,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Institute",
                        modelValue: _ctx.training_institute_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.training_institute_id) = $event)),
                        style: {"width":"100%"},
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCourseList()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: inst.id,
                              label: inst.institute_name,
                              value: inst.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inst.institute_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Course",
                        modelValue: _ctx.course_info_id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.course_info_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"},
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getBatchList()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: course.id,
                              label: course.course_name,
                              value: course.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(course.course_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Batch",
                        modelValue: _ctx.batch_info_id,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch_info_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"},
                        onChange: _ctx.btnCheckStatus
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: batch.id,
                              label: batch.batch_sequence_number,
                              value: batch.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(batch.batch_sequence_number), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.btnCheck)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadIncomeCertified())),
                            type: "button",
                            class: "btn btn-success mt-6 p-3",
                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                          }, [
                            _createTextVNode(" Search"),
                            _hoisted_23
                          ]))
                        : (_openBlock(), _createElementBlock("button", _hoisted_24, [
                            _createTextVNode(" Search"),
                            _hoisted_25
                          ]))
                    ])
                  ])), [
                    [_directive_loading, _ctx.load]
                  ]),
                  (_ctx.showCertifiedData == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  _withDirectives((_openBlock(), _createElementBlock("div", {
                                    class: "row mx-2 mt-3",
                                    key: _ctx.statusKey
                                  }, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _hoisted_35,
                                        _createElementVNode("h4", _hoisted_36, _toDisplayString(this.enrollStatus), 1),
                                        _hoisted_37
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("div", _hoisted_39, [
                                        _hoisted_40,
                                        _createElementVNode("h4", _hoisted_41, _toDisplayString(this.incomecertificateStatus), 1),
                                        _hoisted_42
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _hoisted_45,
                                        _createElementVNode("h4", _hoisted_46, _toDisplayString(this.enrollStatus -
                                    this.incomecertificateStatus), 1),
                                        _hoisted_47
                                      ])
                                    ])
                                  ])), [
                                    [_directive_loading, _ctx.tableLoad]
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                                      _hoisted_49,
                                      _createElementVNode("div", _hoisted_50, [
                                        _hoisted_51,
                                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          _createElementVNode("div", _hoisted_53, [
                                            _createElementVNode("div", _hoisted_54, [
                                              _createElementVNode("div", _hoisted_55, [
                                                _createVNode(_component_Datatable, {
                                                  "table-data": _ctx.uploadStatus,
                                                  "table-header": _ctx.tableHeader,
                                                  "enable-items-per-page-dropdown": true
                                                }, {
                                                  "cell-ref_no": _withCtx(({
                                              row: certificate,
                                            }) => [
                                                    _createTextVNode(_toDisplayString(certificate?.reference_number), 1)
                                                  ]),
                                                  "cell-reg_no": _withCtx(({
                                              row: certificate,
                                            }) => [
                                                    _createTextVNode(_toDisplayString(certificate?.registration_number), 1)
                                                  ]),
                                                  "cell-trainee_name": _withCtx(({
                                              row: certificate,
                                            }) => [
                                                    _createTextVNode(_toDisplayString(certificate?.trainee_name), 1)
                                                  ]),
                                                  "cell-mobile": _withCtx(({
                                              row: certificate,
                                            }) => [
                                                    _createTextVNode(_toDisplayString(certificate?.mobile), 1)
                                                  ]),
                                                  "cell-gender": _withCtx(({
                                              row: certificate,
                                            }) => [
                                                    _createTextVNode(_toDisplayString(certificate?.gender), 1)
                                                  ]),
                                                  "cell-filestatus": _withCtx(({
                                              row: certificate,
                                            }) => [
                                                    (
                                                certificate?.is_poor == 0 ||
                                                (certificate?.is_poor == 1 &&
                                                  certificate
                                                    ?.home_district_info
                                                    ?.is_poor == 0 &&
                                                  certificate?.gender !=
                                                    'Female')
                                              )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, " Not Mendatory "))
                                                      : _createCommentVNode("", true),
                                                    (
                                                (certificate?.is_poor == 1 &&
                                                  certificate
                                                    ?.home_district_info
                                                    ?.is_poor == 1 &&
                                                  !certificate?.income_certificate) ||
                                                (certificate?.is_poor == 1 &&
                                                  certificate?.gender ==
                                                    'Female' &&
                                                  !certificate?.income_certificate)
                                              )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
                                                      : _createCommentVNode("", true),
                                                    (
                                                certificate?.income_certificate
                                              )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_62))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  "cell-actions": _withCtx(({
                                              row: certificate,
                                            }) => [
                                                    (
                                                (certificate?.is_poor == 1 &&
                                                  certificate?.gender ==
                                                    'Female') ||
                                                (certificate?.home_district_info?.is_poor == 1) ||
                                                certificate?.income_certificate
                                              )
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          "data-kt-drawer-toggle": "true",
                                                          "data-kt-drawer-target": "#kt_drawer_certificate_upload",
                                                          onClick: ($event: any) => (
                                                _ctx.uploadcertificate(
                                                  certificate?.id,
                                                  certificate
                                                    ?.income_certificate?.id
                                                )
                                              ),
                                                          "data-bs-toggle": "modal",
                                                          id: "kt_drawer_certificate_upload_button",
                                                          title: "Upload Income Certificate",
                                                          class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                                        }, _hoisted_65, 8, _hoisted_63))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }, 8, ["table-data", "table-header"])
                                              ])
                                            ])
                                          ])
                                        ])), [
                                          [_directive_loading, _ctx.tableLoad]
                                        ])
                                      ])
                                    ]))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_uploadCertificateData)
  ], 64))
}